// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-list[data-v-06da6d9c]{color:#fff!important}.agentRequests.v-list-item--active[data-v-06da6d9c],.customers.v-list-item--active[data-v-06da6d9c],.orders.v-list-item--active[data-v-06da6d9c]{background:#801512}.menu-collection .v-list-item-title[data-v-06da6d9c]{font-size:23px;font-weight:400;line-height:21.33px;text-align:right;color:#434343}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
